import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import ProductTransparencyModal from "@/components/ProductTransparencyModal";

const money = (n) => (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function RetailRankingSection() {
  const [data, setData] = useState(null);
  const [period, setPeriod] = useState("year");
  const [loading, setLoading] = useState(true);
  const [openProduct, setOpenProduct] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/employee/retail-rankings?period=${period}`)
      .then((res) => { if (active) setData(res.data); })
      .catch(() => { if (active) setData(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [period]);

  if (loading) return null;
  if (!data || !data.products || data.products.length === 0) return null;

  return (
    <div className="earnings-body" style={{ paddingTop: 12, paddingBottom: 0 }} data-testid="retail-ranking-section">
      <div style={{ background: "linear-gradient(168deg,#231E1A,#3A2A1E)", borderRadius: 14, padding: 20, color: "#F3EEE7" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
          <div style={{ fontFamily: "Cormorant, serif", fontSize: 22, color: "#F3EEE7" }}>Your Retail</div>
          <div style={{ display: "flex", gap: 6 }}>
            <button data-testid="retail-toggle-year" onClick={() => setPeriod("year")}
              style={{ padding: "6px 12px", borderRadius: 999, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600,
                background: period === "year" ? "#B0905E" : "rgba(243,238,231,0.12)", color: period === "year" ? "#231E1A" : "rgba(243,238,231,0.7)" }}>
              This year
            </button>
            <button data-testid="retail-toggle-all" onClick={() => setPeriod("all")}
              style={{ padding: "6px 12px", borderRadius: 999, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600,
                background: period === "all" ? "#B0905E" : "rgba(243,238,231,0.12)", color: period === "all" ? "#231E1A" : "rgba(243,238,231,0.7)" }}>
              All time
            </button>
          </div>
        </div>
        <div style={{ fontSize: 13, color: "rgba(243,238,231,0.7)", marginBottom: 16 }}>{data.note} <span style={{ color: "rgba(243,238,231,0.5)" }}>· tap a product for its cost story</span></div>

        <div>
          {data.products.map((p) => (
            <div key={p.rank} data-testid={`retail-rank-${p.rank}`}
              onClick={() => setOpenProduct(p.product_name)}
              style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 0", borderTop: p.rank === 1 ? "none" : "1px solid rgba(243,238,231,0.1)", cursor: "pointer" }}>
              <div style={{ fontFamily: "Cormorant, serif", fontSize: 26, fontWeight: 600, color: "#B0905E", width: 30, textAlign: "center", flexShrink: 0 }}>
                {p.rank}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 15, color: "#F3EEE7", fontWeight: 500 }}>
                  {p.product_name} <span style={{ color: "rgba(243,238,231,0.55)", fontWeight: 400 }}>×{p.quantity}</span>
                </div>
              </div>
              <div style={{ fontSize: 15, fontWeight: 600, color: "#B0905E", flexShrink: 0 }}>${money(p.commission)}</div>
            </div>
          ))}
        </div>

        <div style={{ borderTop: "2px solid rgba(243,238,231,0.2)", marginTop: 8, paddingTop: 14, display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
          <div style={{ fontSize: 13, color: "rgba(243,238,231,0.7)" }}>{data.total_products} products · {data.total_items} sold</div>
          <div style={{ fontFamily: "Cormorant, serif", fontSize: 20, color: "#B0905E", fontWeight: 600 }}>${money(data.total_commission)} to you</div>
        </div>
      </div>

      <ProductTransparencyModal
        isOpen={!!openProduct}
        onClose={() => setOpenProduct(null)}
        productName={openProduct}
      />
    </div>
  );
}
